import { styled } from "@mui/system";
import  Button  from "@mui/material/Button";
export const StyledButton = styled(Button, {
    name: "StyledButton"
})({
    color:"white",
    fontWeight:"bold",
   marginTop:'5'
    
})